/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const Control = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.Control {...otherProps} className={className}>
      {children}
    </components.Control>
  );
};

Control.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

Control.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default Control;
